import Vue from 'vue';
import Vuex from 'vuex';

import global from '@/store/global';
import modal from '@/store/modal';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        global,
        modal,
    },
    strict: process.env.NODE_ENV !== 'production',
});
